export const recipesFromDataBase = [
    {
        id: 1,
        name: 'Oatmeal with Berries',
        description:
            'A creamy oatmeal topped with fresh berries for a nutritious start to your day.',
        ingredients: [
            '40g rolled oats',
            '200ml milk (or almond milk)',
            '100g fresh mixed berries',
            '1 tsp honey',
            '1 tsp chia seeds',
        ],
        instructions: [
            'Cook oats with milk in a saucepan over medium heat until creamy (5-7 minutes).',
            'Pour into a bowl and top with berries, honey, and chia seeds.',
        ],
    },
    {
        id: 2,
        name: 'Avocado Toast with Egg',
        description:
            'A classic combination of avocado and egg on whole-grain toast.',
        ingredients: [
            '1 slice whole-grain bread',
            '1/2 medium avocado',
            '1 large egg',
            '1 tsp lemon juice',
            'Salt and pepper to taste',
        ],
        instructions: [
            'Toast the bread.',
            'Mash avocado with lemon juice, salt, and pepper.',
            'Spread avocado on toast and top with the egg.',
        ],
    },
    {
        id: 3,
        name: 'Grilled Chicken Salad',
        description: 'A light and refreshing salad with lean protein.',
        ingredients: [
            '100g grilled chicken breast',
            '2 cups mixed greens',
            '6 cherry tomatoes, halved',
            '1/4 cucumber, sliced',
            '1 tsp olive oil',
            '1 tsp balsamic vinegar',
        ],
        instructions: [
            'Arrange greens, tomatoes, and cucumber on a plate.',
            'Slice grilled chicken and place on top.',
            'Drizzle with olive oil and balsamic vinegar.',
        ],
    },
    {
        id: 4,
        name: 'Quinoa and Veggie Bowl',
        description: 'A nutrient-dense vegetarian dish.',
        ingredients: [
            '50g quinoa',
            '1/2 cup broccoli',
            '1/2 cup carrots',
            '1 tsp soy sauce',
            '1 tsp sesame seeds',
        ],
        instructions: [
            'Cook quinoa as per package instructions.',
            'Steam broccoli and carrots until tender.',
            'Combine quinoa and veggies, then drizzle with soy sauce and sprinkle with sesame seeds.',
        ],
    },
    {
        id: 5,
        name: 'Baked Salmon with Asparagus',
        description: 'A simple and flavorful protein-packed dinner.',
        ingredients: [
            '100g salmon fillet',
            '6 asparagus spears',
            '1 tsp olive oil',
            '1 slice lemon',
            'Salt and pepper to taste',
        ],
        instructions: [
            'Preheat oven to 200°C (400°F).',
            'Place salmon and asparagus on a baking sheet.',
            'Drizzle with olive oil, season with salt and pepper, and bake for 15-18 minutes.',
        ],
    },
    {
        id: 6,
        name: 'Stuffed Bell Peppers',
        description:
            'Colorful peppers filled with lean ground turkey and quinoa.',
        ingredients: [
            '2 bell peppers, halved',
            '100g ground turkey',
            '50g quinoa',
            '2 tbsp tomato paste',
            '1 clove garlic',
        ],
        instructions: [
            'Cook quinoa and sauté turkey with garlic and tomato paste.',
            'Stuff bell peppers with the mixture and bake at 190°C (375°F) for 20 minutes.',
        ],
    },
    {
        id: 7,
        name: 'Greek Yogurt Parfait',
        description: 'A layered snack with yogurt, granola, and fruits.',
        ingredients: ['150g Greek yogurt', '30g granola', '100g strawberries'],
        instructions: [
            'In a glass, layer yogurt, granola, and sliced strawberries.',
        ],
    },
    {
        id: 8,
        name: 'Apple Slices with Peanut Butter',
        description: 'A quick and satisfying snack.',
        ingredients: ['1 medium apple', '1 tbsp peanut butter'],
        instructions: ['Spread peanut butter on apple slices and enjoy.'],
    },
    {
        id: 9,
        name: 'Sweet Potato and Black Bean Tacos',
        description: 'A vegetarian taco loaded with flavor.',
        ingredients: [
            '1 small sweet potato, cubed',
            '50g black beans',
            '2 corn tortillas',
            '2 tbsp salsa',
        ],
        instructions: [
            'Roast sweet potato cubes at 200°C (400°F) for 20 minutes.',
            'Fill tortillas with sweet potato, black beans, and salsa.',
        ],
    },
    {
        id: 10,
        name: 'Turkey and Spinach Wrap',
        description: 'A low-calorie wrap perfect for dinner.',
        ingredients: [
            '1 whole-grain wrap',
            '50g turkey breast slices',
            '1 cup fresh spinach',
            '1 tbsp hummus',
        ],
        instructions: [
            'Spread hummus on the wrap, layer turkey and spinach, and roll tightly.',
        ],
    },
    {
        id: 11,
        name: 'Chickpea Salad',
        description: 'A protein-packed salad.',
        ingredients: [
            '1/2 cup chickpeas',
            '1/4 red onion, diced',
            '1 tbsp parsley, chopped',
            '1 tsp olive oil',
            '1 tsp lemon juice',
        ],
        instructions: [
            'Combine chickpeas, onion, and parsley.',
            'Drizzle with olive oil and lemon juice.',
        ],
    },
    {
        id: 12,
        name: 'Banana and Almond Smoothie',
        description: 'A creamy smoothie for a light meal or snack.',
        ingredients: [
            '1 medium banana',
            '1 cup almond milk',
            '1 tbsp almond butter',
            '3 ice cubes',
        ],
        instructions: ['Blend all ingredients until smooth.'],
    },
];
